import {
  formEncode,
  getToken,
  handleResponse,
  nextFormDataApi,
  nextJsonApi,
} from '@/API/core';

const userRoles = {
  getRoleBasedOnAdminId: async (adminId: string) => {
    let response = null;
    const token = await getToken();
    try {
      response = await nextJsonApi.get(`/user-roles/${adminId}/user`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
    } catch (e) {
      response = e;
    }
    return handleResponse(response);
  },
  updateRolesForUser: async (userId: string, roles: string[]) => {
    let response = null;
    const token = await getToken();
    try {
      response = await nextJsonApi.put(
        `/user-roles/${userId}/update`,
        { roles: roles },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
    } catch (e) {
      response = e;
    }
    return handleResponse(response);
  },
};

export default userRoles;
